<!-- @format -->
<template>
    <p>{{ $t('description') }}</p>
</template>
<script>
export default {
    name: 'BookingContentStatusRefunded',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBooking.bookingContent.refunded',
    },
};
</script>
